import { render } from "./ProjectNavigation.vue?vue&type=template&id=17f35d7e&scoped=true"
import script from "./ProjectNavigation.vue?vue&type=script&lang=js"
export * from "./ProjectNavigation.vue?vue&type=script&lang=js"

import "./ProjectNavigation.vue?vue&type=style&index=0&id=17f35d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f35d7e"]])

export default __exports__